import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import NotFound from "./containers/NotFound";
import Login from "./containers/Login";
import ForgotPassword from "./containers/ForgotPassword";
import AppliedRoute from "./components/AppliedRoute";
import Signup from "./containers/Signup";
import Account from "./containers/Account";
import Projects from "./containers/Projects";
import WeatherList from "./containers/WeatherList";
import SensorDataList from "./containers/SensorDataList";
import Trips from "./containers/Trips";
import Organisations from "./containers/Organisations";
import Organisation from "./containers/Organisation";
//import NewNote from "./containers/NewNote";
import NewOrg from "./containers/NewOrg";
import NewProject from "./containers/NewProject";
import NewSchemaVersion from "./containers/NewSchemaVersion";
import Project from "./containers/Project";
//import MainMapPage from "./containers/main_map_page";
import Trip from "./containers/Trip";
//import Notes from "./containers/Notes";
import NewOrgUser from "./containers/NewOrgUser";
import OrgUser from "./containers/OrgUser";
//import Builder from "./containers/Builder";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
//import MxGraph from "./containers/MxGraph";
//import MxGraph2 from "./containers/MxGraph2";


//import EnhancedTableHead from "./containers/EnhancedTableHead";

export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path="/" exact component={Home} props={childProps}/>
	<UnauthenticatedRoute path="/login" exact component={Login} props={childProps}/>
	<UnauthenticatedRoute path="/forgot" exact component={ForgotPassword} props={childProps}/>
	<UnauthenticatedRoute path="/signup" exact component={Signup} props={childProps}/>
	<AuthenticatedRoute path="/account" exact component={Account} props={childProps}/>
	<AuthenticatedRoute path="/organisations" exact component={Organisations} props={childProps}/>
	<AuthenticatedRoute path="/organisations/new" exact component={NewOrg} props={childProps}/>
	<AuthenticatedRoute path="/organisations/:id" exact component={Organisation} props={childProps}/>
	<AuthenticatedRoute path="/organisations/:id/users/add" exact component={NewOrgUser} props={childProps}/>
	<AuthenticatedRoute path="/organisations/users/:id" exact component={OrgUser} props={childProps}/>
  <AuthenticatedRoute path="/weather" exact component={WeatherList} props={childProps}/>
  <AuthenticatedRoute path="/sensordata" exact component={SensorDataList} props={childProps}/>
  <AuthenticatedRoute path="/projects" exact component={Projects} props={childProps}/>
	<AuthenticatedRoute path="/projects/schemas/trips" exact component={Trips} props={childProps}/>
	<AuthenticatedRoute path="/projects/schemas/trips/trip" exact component={Trip} props={childProps}/>
	<AuthenticatedRoute path="/projects/new" exact component={NewProject} props={childProps}/>
  <AuthenticatedRoute path="/projects/edit" exact component={NewProject} props={childProps}/>
  <AuthenticatedRoute path="/projects/schemas/edit" exact component={NewSchemaVersion} props={childProps}/>
	<AuthenticatedRoute path="/projects/:id" exact component={Project} props={childProps}/>
  <AuthenticatedRoute path="/builder" exact component={() => window.location = ''} props={childProps}/>
    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;



// WEBPACK FOOTER //
// ./src/Routes.js